import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {MeasurementSeriesRange} from '../application/ports/body-measurements.repository';
import type {BodyMetricId} from '../domain/body-metric-id.value-object';
import type {BodyMeasurementsDependencies} from '../dependencies';
import {keys} from './keys';

export type GetMeasurementSeriesQueryDependencies = Pick<
  BodyMeasurementsDependencies,
  'controllers'
>;

export const getMeasurementSeriesQuery = (
  {controllers}: GetMeasurementSeriesQueryDependencies,
  metricId: BodyMetricId,
  range: MeasurementSeriesRange,
) =>
  queryOptions({
    queryKey: keys.series(metricId, range),
    queryFn: () => controllers.bodyMeasurementsController.series(metricId, range).then(unwrap),
  });
